"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.imageDefaultProps = exports.imagePropTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _lazyImage = _interopRequireWildcard(require("../lazy-image"));

var _placeholderImage = _interopRequireDefault(require("../placeholder-image"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Render an image media type from Contentful.
 *
 * If passed `lazy` will render it as lazy loaded. See ../lazy-image for more info
 *
 * It utilizes the Contentful Image API to retrieve a low quality placeholder image.
 * This prevents content from jumping around when users scroll and images have not yet loaded.
 * The low quality image also is Server Side Rendered.
 */
// eslint-disable-next-line react/prefer-stateless-function
var Image = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Image, _React$PureComponent);

  var _super = _createSuper(Image);

  function Image() {
    _classCallCheck(this, Image);

    return _super.apply(this, arguments);
  }

  _createClass(Image, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          height = _this$props.height,
          lazy = _this$props.lazy,
          lazyLoadProps = _this$props.lazyLoadProps,
          media = _this$props.media,
          width = _this$props.width;
      var queryPropsMap = {};

      if (width) {
        queryPropsMap.w = width;
      }

      if (height) {
        queryPropsMap.h = height;
      }

      var queryProps = (0, _lodash["default"])(queryPropsMap).toPairs().map(function (pair) {
        return "".concat(pair[0], "=").concat(pair[1]);
      }).join('&');

      var src = _lodash["default"].get(media, 'fields.file.url');

      var alt = _lodash["default"].get(media, 'fields.title'); // format is jpg for all browser support and quality manipulation


      var lowQualitySrc = "".concat(src, "?fm=jpg&q=1&").concat(queryProps);
      var highQualitySrc = "".concat(src, "?").concat(queryProps);

      var placeholder = /*#__PURE__*/_react["default"].createElement(_placeholderImage["default"], {
        className: className,
        src: lowQualitySrc,
        alt: alt
      });

      return /*#__PURE__*/_react["default"].createElement(_lazyImage["default"], {
        alt: alt,
        className: className,
        lazy: lazy,
        lazyLoadProps: lazyLoadProps,
        placeholder: placeholder,
        src: highQualitySrc
      });
    }
  }]);

  return Image;
}(_react["default"].PureComponent);

var imagePropTypes = {
  className: _propTypes["default"].string,
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  lazy: _propTypes["default"].bool,
  media: _propTypes["default"].shape({
    fields: _propTypes["default"].shape({}),
    sys: _propTypes["default"].shape({})
  }),
  // see ../LazyImage for prop options
  lazyLoadProps: _propTypes["default"].shape(_objectSpread({}, _lazyImage.lazyLoadPropType)),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
exports.imagePropTypes = imagePropTypes;
var imageDefaultProps = {
  className: '',
  height: null,
  lazy: true,
  media: {},
  // lazy load props
  lazyLoadProps: _lazyImage.lazyLoadDefaultProp,
  width: null
};
exports.imageDefaultProps = imageDefaultProps;
Image.propTypes = imagePropTypes;
Image.defaultProps = imageDefaultProps;
var _default = Image;
exports["default"] = _default;